import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

// 

const SkeletonProgress = ({ rowCount = 2, width=500 }) => {
  return (
    <>
      <Grid container sx={{mt:1}}>
        <Grid item sx={{ width: "54px" }}>
          <Skeleton
            animation="wave"
            variant="circular"
            width={40}
            height={40}
          />
        </Grid>
        <Grid item>
        {Array.from(Array(rowCount), (e, i) => {
          return <Skeleton variant="rectangular" width={width} height={20} sx={{mb:1}} />;
        })}
        </Grid>
      </Grid>
      <br />
    </>
  );
};

export default SkeletonProgress;
